module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 33
// module chunks = 0